import React from "react";
import Header from "../../../components/Header/Header";
import CategoryCourseCard from "../../../components/Courses-section/Categories/CategoryCourseCard";
import Features from "../../../components/Feature-section/Features";
import Newsletter from "../../../components/Newsletter/Newsletter";
import Footer from "../../../components/Footer/Footer";
import HeadSection from "../../../components/meta";

const CourseByCategory = ({ courses }) => {
  // console.log({courses});
  
  return (
    <>
      <HeadSection
        title={`${
          courses.category ? courses.category.toUpperCase() : ""
        } | COURSES | SEED TO TREE`}
        keywords={""}
        addPostFixTitle={true}
        largeTwitterCard={true}
        showCanonical={true}
        link={`/courses/${courses.category}`}
        content={`${courses.category ? courses.category.toUpperCase() : ""} category course page to show all courses that are being offered by seed to tree Academy.`}
      />
      <Header isActive={courses.category} />
      <section id={courses.category} className="courses">
        <div className="course__top d-flex justify-content-between align-items-center flex-wrap">
          <div className="course__top__left w-60">
            <h1>{courses.category ? courses.category.toUpperCase() : "NA"} Courses</h1>
          </div>

          <div className="w-50 text-end">
            {/* <button className="btn">See All</button>  */}
          </div>
        </div>
        <div className="courses__category__list">
          {courses && courses.data && courses.data.length > 0 ? (
            courses.data.map((course) => (
              <CategoryCourseCard key={course.slug} course={course} />
            ))
          ) : (
            <h3>Coming Soon!!!</h3>
          )}
        </div>
      </section>
      <Features />
      <Newsletter />
      <Footer />
    </>
  );
};

export default CourseByCategory;
